module.exports = __webpack_public_path__ + "assets/Device_Multiple_light.png";